import { Component, Inject, ViewChild, forwardRef } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ErrorMessages } from "../../common/constants";
import { ActionDiscardReason, ActionStatus } from "../../model";
import { ActionDiscardReasonService } from "../../service/action-discard-reason.service";
import { ErrorUtility } from "../../utility/error-utility";


@Component({
    selector: 'discard-action-dialog',
    template: require('./discard-action-dialog.component.html')
})
export class DiscardActionDialogComponent {

    @ViewChild('form') form: NgForm;

    error: string;
    actionDiscardReasons: ActionDiscardReason[];
    textAreaPlaceholder: string = "Enter a brief description of the reason or context that led to discard the actions";
    mandatoryDiscardReason: boolean;
    loaded: boolean;
    actionStatus: ActionStatus;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<DiscardActionDialogComponent>,
        @Inject(forwardRef(() => ActionDiscardReasonService)) private actionDiscardReasonService: ActionDiscardReasonService,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.loadActionDiscardReasons();
        this.actionStatus = data.actionStatus;
        this.mandatoryDiscardReason = this.actionStatus ? this.actionStatus.actionDefinition?.mandatoryDiscardReason : true;
    }

    private loadActionDiscardReasons(): void {
        this.actionDiscardReasonService.getAllActionDiscardReasons().then(reasons => {
            this.actionDiscardReasons = reasons;
            this.loaded = true;
        }).catch(err => {
            this.error = ErrorUtility.getMessage(err, ErrorMessages.GET_DATA_ERROR);
            this.loaded = true;
        });
    }

    discard(): void {
        this.dialogRef.close(this.form.form.getRawValue());
    }

}